import { vnAppZone } from "../vnApp/vn_app_zone";
import { arraysMerge } from "../vnHelpers/helper_functions";
import { XMLHttpRequestHandler } from "../XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../XMLHttpRequestHandler/XMLHttpRequestHandler";
export class vnApp {
    // Access types.
    static { this.ACCESS_TYPE_READ = 'r'; }
    static { this.ACCESS_TYPE_WRITE = 'w'; }
    static { this.ACCESS_TYPE_UPDATE = 'u'; }
    static { this.ACCESS_TYPE_DELETE = 'd'; }
    constructor(zones) {
        this._isLeavePageWarningNeeded = false;
        this.loggedUser = { user: null, isLoggedIn: false, lastIsLoggedIn: false };
        this._routeHistory = [];
        this.zones = zones;
        this.defineRoutes();
        this.addWarningEventListeners();
    }
    // PROPERTIES
    get params() {
        return this._params;
    }
    set params(params) {
        this._params = params;
    }
    get routeHistory() {
        return this._routeHistory;
    }
    set routeHistory(params) {
        this._routeHistory = params;
    }
    get isLeavePageWarningNeeded() {
        return this._isLeavePageWarningNeeded;
    }
    set isLeavePageWarningNeeded(isLeavePageWarningNeeded) {
        this._isLeavePageWarningNeeded = isLeavePageWarningNeeded;
    }
    addRouteHistory(params) {
        this._routeHistory.push(params);
        if (this._routeHistory.length > 5) {
            this._routeHistory.shift();
        }
    }
    getLastRoute() {
        if (this._routeHistory[this._routeHistory.length - 2]) {
            return this._routeHistory[this._routeHistory.length - 2];
        }
        else {
            // default to home "/"
            return "/";
        }
    }
    getCurrentRoute() {
        if (this._routeHistory[this._routeHistory.length - 1]) {
            return this._routeHistory[this._routeHistory.length - 1];
        }
        else {
            // default to home "/"
            return "/";
        }
    }
    get zones() {
        return this._zones;
    }
    set zones(zones) {
        this._zones = zones;
    }
    get loggedUser() {
        return this._loggedUser;
    }
    set loggedUser(loggedUser) {
        this._loggedUser = loggedUser;
    }
    getIsLoggedInHttpCallParameters() {
        return [];
    }
    getIsLoggedInHttpCallResponse(rawResponse) {
        return rawResponse;
    }
    getZoneByName(name) {
        for (let z of this.zones) {
            if (z.zoneName == name) {
                return z;
            }
        }
        return null;
    }
    setLoggedInStatus() {
        let thisApp = this;
        let promiseObj = new Promise(function (fullfill, reject) {
            //setTimeout(function(){ console.log("Hello"); }, 5000);
            // loading the page if the user is logged in
            let loginReq_url = thisApp.getIsLoggedInHttpCallUrl();
            let loginReq_Params = thisApp.getIsLoggedInHttpCallParameters();
            let contextPageCtrl = this;
            let XHRHdl = new XMLHttpRequestHandler(loginReq_url, loginReq_Params, this);
            XHRHdl.onReadyStateFunction = (function (req, obj) {
                return function () {
                    if (req.request.readyState == 4) {
                        if (req.request.status == 200) {
                            let responseParsed = thisApp.getIsLoggedInHttpCallResponse(JSON.parse(req.request.response));
                            console.log(responseParsed);
                            let lastLog = thisApp.loggedUser.isLoggedIn;
                            if (responseParsed.isLoggedIn === true) {
                                thisApp.loggedUser = responseParsed;
                                thisApp.loggedUser.lastIsLoggedIn = lastLog;
                                thisApp.loggedUser.isLoggedIn = responseParsed.isLoggedIn;
                                console.log("User session is active.");
                            }
                            else {
                                thisApp.loggedUser.user = null;
                                thisApp.loggedUser.lastIsLoggedIn = lastLog;
                                thisApp.loggedUser.isLoggedIn = false;
                                console.log("User session is NOT active.");
                            }
                            fullfill();
                        }
                        else {
                            console.log("User session is NOT active.");
                            reject();
                        }
                    }
                };
            });
            XHRHdl.execute();
        });
        return promiseObj;
    }
    //
    // Define all the routes in the "page" library
    // for this app, so, for all the zones
    defineRoutes() {
        //
        // Obtain all the zone's arrays of [path, function]
        // ** while we get all the routesActions we gather the different valid paths
        let tempRoutes = [];
        let validRoutes = [];
        for (let zone of this.zones) {
            tempRoutes.push(zone.routesActions);
            for (let actions in zone.routesActions) {
                if (validRoutes.indexOf(actions) === -1) {
                    validRoutes.push(actions);
                }
            }
        }
        //
        // Apply the "ALL" routes settings
        // if a zone has an action setted to "all"
        // we automaticaly add it to all valid path that does not have an action already
        for (let r of tempRoutes) {
            // does that zone have a "all" script
            if ("all" in r) {
                for (let v of validRoutes) {
                    if (!(v in r)) {
                        r[v] = r["all"];
                    }
                }
            }
        }
        //
        // Merge all the arrays of [path, function] in one array
        // ** the "page" lib does not cumulate all actions for the same path
        // so we do it before setting the routes
        let mergedRoutes;
        mergedRoutes = arraysMerge(tempRoutes);
        //
        // For each of the route present in the merged array
        // add all the functions as calls on the "page" library event
        for (let route in mergedRoutes) {
            let routeActions = mergedRoutes[route];
            let _this = this;
            page(route, function (ctx) {
                _this.params = ctx.params;
                let bodyClasses = [];
                // Get subdomain for body class
                let host = window.location.host;
                let hostParts = host.split('.');
                if (hostParts.length > 2) {
                    let subdomain = hostParts[0];
                    bodyClasses.push(subdomain);
                }
                // Get route for body class
                let routeClasses = route.replace('/', ' _').replace(/\//g, ' _').split(' ');
                bodyClasses = bodyClasses.concat(routeClasses);
                // Set subdomain and route in body class
                document.getElementsByTagName("body")[0].className = bodyClasses.join(' ');
                let setLoginPromise = _this.setLoggedInStatus();
                setLoginPromise.then(function (ctx) {
                    _this.addRouteHistory(window.location.pathname);
                    for (let action of routeActions) {
                        if (_this.loggedUser.isLoggedIn || action[1] == null) {
                            action[0].call();
                        }
                        else {
                            action[1].call();
                        }
                    }
                }, function () { console.log("Error in the login"); });
            });
        }
        page('*', function () {
            page.redirect('/?redirected=1');
        });
        page.start();
    }
    addWarningEventListeners() {
        let self = this;
        window.addEventListener('popstate', function (event) {
            self.popStateFunction(self.isLeavePageWarningNeeded, self.zones, event);
        });
        self._beforeUnloadEventListener = event => {
            event = event || window.event;
            if (self.isLeavePageWarningNeeded) {
                if (event) {
                    event.returnValue = ' ';
                    return event;
                }
                if (!event.defaultPrevented) {
                    event.returnValue = null;
                }
            }
            return event;
        };
        window.addEventListener('beforeunload', self._beforeUnloadEventListener);
    }
    removeWarningEventListeners() {
        let self = this;
        window.removeEventListener('beforeunload', self._beforeUnloadEventListener);
    }
    popStateFunction(isLeavePageWarningNeeded, zones, event) {
        if (isLeavePageWarningNeeded) {
            if (!confirm("You are about to leave the page. Any unsaved changes will be lost.")) {
                //pushing the current state of the web app so it doesn't trigger a reload
                history.pushState(true, null, null);
                return event;
            }
            else {
                for (let zone of zones) {
                    zone.loadedModule.cancelForm();
                }
            }
        }
    }
    windowOnBeforeUnloadFunction(event, isLeavePageWarningNeeded) {
        event = event || window.event;
        if (isLeavePageWarningNeeded) {
            if (event) {
                event.returnValue = ' ';
                return event;
            }
            if (!event.defaultPrevented) {
                event.returnValue = null;
            }
        }
        return event;
    }
    isFirstLoad() {
        return this._routeHistory.length == 1;
    }
}
